import { Protocol } from './index';
import { Category } from '../constants';

const bridges: Protocol[] = [
  {
    name: 'Abstract Native Bridge',
    url: 'https://portal.testnet.abs.xyz/bridge/',
    logoPath: '/logos/abstract_native_bridge.jpg',
    category: Category.Bridge,
    twitterUrl: 'https://x.com/AbstractChain',
  }
];

export { bridges };
